import { AxiosInstance } from '../../utils/RequestMethods'
import config from '../../constants/config'
import { UserT } from '../../types/Users'

export const getCurrentUser = async (): Promise<UserT> => {
    return AxiosInstance.get(`${config.url.wpJson}/wp/v2/users/me`).then((res) => {
        if (res && res.data) {
            return res.data
        }
    }).catch((error) => {
        console.log("error->getCurrentUser", error)
        return Error(error)
    })
}

export const updateCurrentUser = async (params = {}): Promise<UserT> => {
    try {
        let res = await AxiosInstance.post(`${config.url.wpJson}/wp/v2/users/me`, params)
        if (res && res.data) {
            return res.data
        }
    } catch (error) {
        throw new Error(error)
    }
}
